module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "text",
      "placeholder": "Search profile..."
    },
    on: {
      "clear": _vm.reset
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchProfile($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [_c('el-button', {
          attrs: {
            "disabled": !_vm.canSearch
          },
          nativeOn: {
            "click": function($event) {
              return _vm.searchProfile($event)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-search"
        }), _vm._v(" Search Profile\n      ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.identifier),
      callback: function($$v) {
        _vm.identifier = $$v
      },
      expression: "identifier"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cb5510b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/filters/IdentifiersFilter.vue
// module id = 3353
// module chunks = 3